/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Avatar, IconButton, Typography, Divider, Paper, Chip, Collapse, Tooltip, Backdrop } from '@material-ui/core'
import { AvatarGroup } from '@material-ui/lab'
import { ExpandMore, ExpandLess, Input, DeviceHub , FlashOn} from '@material-ui/icons'

import InformationUnit from '../InformationUnit/InformationUnit'
import Operation from '../Operation/Operation'
import Add from "@material-ui/icons/Add";
import TimeLine from './TimeLine'
import AddDataDevice from "../../../CreateIC/AddDataDevice";
import Scheduler from '../../../Scheduler/Scheduler'
import Actions from '../../../../fluid/Actions/ActionFactory'
import SecureWrapper from "../../../Security/SecureWrapper";

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#FF6701",
        contrastText : "#FFFFFF"
      },
    },
});

const styles = theme => ({

})

class InformationChannel extends Component {
    state = {
        open_iu : true,
        open_op : true,
        timeline_filters : {},
        addingIU: false
    }

    toggleState = (state_key) => {
        this.setState({
            ...this.state,
            [state_key] : !this.state[state_key]
        })
    }

    isIUAddEnabled = () => {
        try {
          //if operations are not configured for given ic , do not enable add IU button
          return this.props.ic.world_view.configs.length > 0;
        } catch (err) {
          return false;
        }
      };

    containsSchedulableOperations = () => {
        let schedulable_ops = this.props.ic.operationAnnotations.filter(op => op.is_schedulable === true)

        if (schedulable_ops.length > 0) {
            console.log(this.props.ic.name + " containsSchedulableOperations :", true )
            return true
        } else {
            console.log(this.props.ic.name + " containsSchedulableOperations :", false )
            return false
        }
    }

    firstDataTransferCompleted = () => {
        console.log(this.props.ic.name + " IUs: ", this.props.ic.information_units)
        let trainable_ius = this.props.ic.information_units.filter(iu => iu.config_type === "Trainable")

        if (trainable_ius.length === 0) {
            return false
        }

        if (this.props.ic.scheduleJob !== null) {
            return true
        }

        console.log(this.props.ic.name + " Trainable IUs: ", trainable_ius)
        let first_transfer_complete_iu = trainable_ius.filter(iu => iu.data_transfer_status_object.length > 0 && 
            iu.data_transfer_status_object.sort((a,b) => new Date(a.end_time) - new Date(b.end_time))[iu.data_transfer_status_object.length - 1].status === 'Completed')
        console.log(this.props.ic.name + " first_transfer_complete_iu", first_transfer_complete_iu)
        if (first_transfer_complete_iu.length === trainable_ius.length) {
            console.log(this.props.ic.name + " firstDataTransferCompleted :", true )
            return true
        } else {
            console.log(this.props.ic.name + " firstDataTransferCompleted :", false )
            return false
        }
    }

    pauseJob = (row_data) => {
        let { scheduleJob } = row_data;
        let { group_name, job_name } = scheduleJob;
    
        Actions("http_request", {
          url:
            "/sainapse/schedule/pause?groupName=" +
            group_name +
            "&jobName=" +
            job_name,
          method: "post",
          data: {},
        })
          .then((res) => {
            this.props.refresh();
          })
          .catch((err) => {
            console.log(err);
            this.props.updateErrorFromScheduler(err);
          });
    };

    resumeJob = (row_data) => {
        let { scheduleJob } = row_data;
        let { group_name, job_name } = scheduleJob;
        Actions("http_request", {
            url:
            "/sainapse/schedule/resume?groupName=" +
            group_name +
            "&jobName=" +
            job_name,
            method: "post",
            data: {},
        })
        .then((res) => {
            this.props.refresh();
        })
        .catch((err) => {
            console.log(err);
            this.props.updateErrorFromScheduler(err);
        });
    };

    deleteJob = (row_data) => {
        let { scheduleJob } = row_data;
        let { group_name, job_name } = scheduleJob;
        Actions("http_request", {
            url:
            "/sainapse/schedule?groupName=" + group_name + "&jobName=" + job_name,
            method: "delete",
            data: {},
        })
        .then((res) => {
            this.props.refresh();
        })
        .catch((err) => {
            console.log(err);
            this.props.updateErrorFromScheduler(err);
        });
    };

    setSchedule = (schedule, row_data) => {
        let ic_name = row_data.name;

        const retrain_request = {
            ic_name: ic_name,
            operations: row_data.operations,
        };

        Actions("http_request", {
            url: "/sainapse/schedule",
            method: "post",
            data: {
            cron_expression: schedule.cron_expression,
            end_time: schedule.end_time,
            group: schedule.group_name,
            name: schedule.job_name,
            start_time: schedule.start_time,
            retrain_request: retrain_request,
            },
        })
        .then((res) => {
            this.props.refresh();
        })
        .catch((err) => {
            console.log(err);
            this.props.updateErrorFromScheduler(err);
        });
    };

    
    renderInformationUnits = () => {
        return (
            <Paper style = {{backgroundColor : '#F0F0F0', marginBottom : '3px', borderRight : this.state.open_iu ? '3px solid #2296f3' : '1px solid rgba(0,0,0,0.12)'}} variant = 'outlined' square>
                <div 
                    style = {{width : '100%', cursor :'pointer', marginBottom : '5px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}
                    onClick = {() => this.toggleState('open_iu')}
                >
                    <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems :'center'}}>
                        {this.state.open_iu ? null : <AvatarGroup>
                            {this.props.ic.information_units.map(iu => <Tooltip title = {iu.name}><Avatar style = {{width : '30px', height : '30px', backgroundColor : "#FFFFFF", borderColor : '#2296f3'}}><Input style = {{fontSize : '14px', color : '#2296f3'}}/></Avatar></Tooltip>)}
                        </AvatarGroup>}
                        <Typography style = {{marginLeft : '10px'}} variant = 'subtitle2' color ='primary'>{"Information Units"}</Typography>
                        
                    </div>
                    <IconButton size = 'small' disableFocusRipple>
                        {this.state.open_iu ? <ExpandLess/> : <ExpandMore/>}
                    </IconButton>
                </div>
                <Collapse in = {this.state.open_iu}>
                    <div style = {{width : '100%', backgroundColor : '#FFFFFF'}}>
                        {this.props.ic.information_units.sort((a, b) => {
                            if(a.name < b.name) { return -1; }
                            if(a.name > b.name) { return 1; }
                            return 0;
                        }).map(iu => <InformationUnit ic = {this.props.ic} iu = {iu} show_connection = {true} show_data_transfer = {true} show_actions = {true} refresh = {this.props.refresh}/>)}
                    </div>
                </Collapse>
            </Paper>
        )
    }

    renderOperations = () => {
        return (
            <Paper style = {{backgroundColor : '#F0F0F0', borderRight: this.state.open_op ? '3px solid #FF6701' : '1px solid rgba(0,0,0,0.12)'}} variant = 'outlined' square>
                <div 
                    style = {{width : '100%', cursor :'pointer', marginBottom : '5px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}
                    onClick = {() => this.toggleState('open_op')}
                >
                    <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems :'center'}}>
                        {this.state.open_op ? null : <AvatarGroup>
                            {
                                this.props.ic.operations.map(op => {
                                    let op_name = this.props.ic.operationAnnotations.find(op_annot => op_annot.type === op).annotation
                                    return (
                                        <Tooltip title = {op_name}>
                                            <Avatar style = {{width : '30px', height : '30px', backgroundColor : "#FFFFFF", borderColor : "#FF6701"}}>
                                                <FlashOn style = {{fontSize : '15px', color : '#FF6701'}}/>
                                            </Avatar>
                                        </Tooltip>)
                                })
                            }
                        </AvatarGroup>}
                        <Typography style = {{marginLeft : '10px'}} variant = 'subtitle2' color ='secondary'>Operations</Typography>
                    </div>
                    <IconButton size = 'small' disableFocusRipple>
                        {this.state.open_op ? <ExpandLess/> : <ExpandMore/>}
                    </IconButton>
                </div>
                <Collapse in = {this.state.open_op}>
                    <div style = {{width : '100%', backgroundColor : '#FFFFFF'}}>
                        {this.props.ic.operations.map(op => <Operation ic = {this.props.ic} op = {op} size = "large" refresh = {this.props.refresh} op_label = {true}/>)}
                    </div>
                </Collapse>
            </Paper>
        )
    }

   
    

    render() { 
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper square style = {{width : '100%', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', backgroundColor : '#F0F0F0'}}>
                        <div style = {{padding : '10px', flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <div>
                                <Tooltip title = "Information Channel">
                                    <Avatar style = {{backgroundColor : "#0bb5b0"}}>
                                        <DeviceHub fontSize = 'small'/>
                                    </Avatar>
                                </Tooltip>
                            </div>
                            <div>
                                <Typography style = {{marginLeft : '10px',color : "#0bb5b0", fontSize : '16px', fontWeight : '500'}} variant = 'h6' >{this.props.ic.name}</Typography>
                            </div>
                        </div>
                        <div style = {{padding : '10px', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                            <Typography style = {{display : 'block', marginLeft : '2px'}} variant = 'caption' color = 'textSecondary'>{"Information Units"}</Typography>
                            {this.props.ic.information_units.map(iu => <Chip style = {{margin : '2px'}} label = {iu.name} size = 'small' color = 'primary'/>)}
                            <SecureWrapper
                                access_object = {{
                                    operation : "/sainapse/information_channel/{ic_name}/information_unit",
                                    method : "POST",
                                    operands : [
                                    {
                                        attrName: "ic_name",
                                        value : this.props.ic.name
                                }]
                                }}
                            >
                            <Tooltip
                                title="Create New IU"
                                disabled={!this.isIUAddEnabled()}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.handleCreateIUDialogOpen();
                                }}
                            >
                                <IconButton color="primary" size = 'small'>
                                    <Add fontSize = 'small'/>
                                </IconButton>
                            </Tooltip>
                            </SecureWrapper>
                        </div>
                        <div style = {{padding : '10px', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                            <Typography style = {{display : 'block', marginLeft : '2px'}} variant = 'caption' color = 'textSecondary'>Operations</Typography>
                            {this.props.ic.operations.map(op => <Chip style = {{margin : '2px'}} label = {this.props.ic.operationAnnotations.find(opt => opt.type === op).annotation} size = 'small' color = 'secondary'/>)}
                        </div>
                        {this.containsSchedulableOperations() && this.firstDataTransferCompleted() && <div style = {{padding : '10px', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                            <Typography style = {{display : 'block', marginLeft : '2px'}} variant = 'caption' color = 'textSecondary'>{"Retraining Schedule"}</Typography>
                            <div style={{ maxWidth: "350px" }}>
                                <Scheduler
                                    key={new Date().getTime()}
                                    scheduleJob={
                                        this.props.ic.scheduleJob === undefined
                                        ? null
                                        : this.props.ic.scheduleJob
                                    }
                                    group_name="ReTrain"
                                    submit_schedule={(schedule) =>
                                        this.setSchedule(schedule, this.props.ic)
                                    }
                                    pause={(job_name) => this.pauseJob(this.props.ic)}
                                    resume={(job_name) => this.resumeJob(this.props.ic)}
                                    delete={(job_name) => this.deleteJob(this.props.ic)}
                                />
                            </div>
                        </div>}
                    </div>
                    <Divider/>
                    <div style = {{width : '100%', height : '50vh', display : 'flex', flexDirection : 'row'}}>
                        <div style = {{width : '40%', height : '100%',borderRight : '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'column'}}>
                            <div>
                                <Typography style = {{margin : '5px'}} variant = 'subtitle2'>Overview</Typography>
                            </div>
                            <div style = {{width : '100%', flexGrow : 1, overflow : 'scroll'}}>
                                {this.renderInformationUnits()}
                                {this.renderOperations()}
                            </div>
                        </div>
                        <div style = {{width : '60%', height : '50vh', display : 'flex', flexDirection : 'row'}}>
                            <div style = {{width : '100%', height : '50vh', display : 'flex', flexDirection : 'column'}}>
                                <div>
                                    <Typography style = {{margin : '5px'}} variant = 'subtitle2' color = 'primary'>Timeline</Typography>
                                    <Divider/>
                                </div>
                                <div style = {{width : '100%', flexGrow : 1, overflow : 'scroll', backgroundColor : '#FAFAFA'}}>
                                    <TimeLine ic = {this.props.ic} />
                                </div>
                            </div>
                            {/* <div style = {{width : '25%', height : '50vh', overflow : 'scroll', backgroundColor : '#F0F0F0', padding : '5px'}}>
                                <Typography variant = 'subtitle2'>Timeline Filters</Typography>
                                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                            </div> */}
                        </div>
                    </div>
                </Paper>
                {/* {this.renderCreateIUDialog} */}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(InformationChannel);